export default __webpack_public_path__ + "static/media/chevron-up-charcoal.e475a9a9.svg";